import { KEY_REDUCER_SW } from "@/shared/store/sw/constants";

export const selectorStatusesWebsiteUrlsForOfflineUse = (state) => {
  return state[KEY_REDUCER_SW].websiteUrlsStatuses;
};